<div  (drop)="drop($event)" 
      (dragover)="dragOver($event)" 
      (dragleave)="dragLeave($event)" 
      (click)="fileInput.value = '';fileInput.click()"
      [ngStyle]="{
        height:(dragDropHeightObs | async)
      }" 
      class="file-drag-drop-box border-radius-standard flex-column flex--align-center" 
      [ngClass]="{
        'border-warn':showErrorObs | async,
        'border-primary':!(showErrorObs | async)
      }"
>

    <p  class="upload-file-text margin-none mat-headline-6" 
        [ngClass]="{
          'warn-text':showErrorObs | async,
          'primary-text-900':!(showErrorObs | async)
        }"
      > 
        {{"ss-entities.document.upload" | translate}} 
      </p>
</div>

<input #fileInput hidden type="file" multiple (change)="uploadFiles($event)" accept=".pdf">
<p *ngIf="showErrorObs | async" class="warn-text">{{"ss-entities.document.no-documents" | translate}}</p>